/* --- Test --- */
export const MOCK_ACTIVE = false;
export const MOCK_LOG = MOCK_ACTIVE;
export const LIFERAY_TEST = MOCK_ACTIVE;
export const LD_TEST_OBJECT = {
  BASE_URL: 'https://apigw-dev2.smiles.com.br',
  APP_CONFIG_URL: 'https://appconfig-blue.smiles.com.br',
  LIFERAY6_SITE_ID: '10184',
  RECSYS_ENGINE_API: 'https://recsys-engine-dev1.smiles.com.br',
};
/* --- end Test --- */

export const LD_CLIENT_SIDE_ID = '5dc03c40125008088b5cf13e';
export const LD_BASE_URL = 'https://ldrelay.smiles.com.br';

export const EVENT_KEY = 'smls-optin-open';

export const JWT_MEMBER_NUMBER_KEY = 'https://smiles.api/memberNumber';

export const ERROR_USER_REGISTERED = '140';

export const API_LIVERAY_URL = 'https://api-cms-portal-{{env}}.smiles.com.br';
